import Repository from './Repository';

const resource = '/avaliacoes';

export default {
  getAll(diagnostico) {
    return Repository.get(`${resource}?diagnostico=${diagnostico}`);
  },
  finalizar(avaliacoesIds) {
    return Repository.put(`${resource}`, avaliacoesIds);
  },
  relatorios(diagnosticoId, unidadesIds) {
    const unidadesParam = unidadesIds.reduce((acumulador, u) => acumulador.concat(`&unidade=${u}`), '');
    return Repository.get(`${resource}/diagnostico/${diagnosticoId}/relatorio?${unidadesParam}`);
  },
};
